import { forwardRef } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@ui/lib/utils'

const iconVariants = cva('inline-block', {
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export interface IconProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof iconVariants> {
  name: string // Font Awesome class (e.g., 'fa-solid fa-heart')
}

export const Icon = forwardRef<HTMLElement, IconProps>(
  ({ name, size, className, ...props }, ref) => {
    return <i ref={ref} className={cn(name, iconVariants({ size, className }))} {...props} />
  }
)

Icon.displayName = 'Icon'
